import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import { TypeChecker } from '@attain-apps/type-guards'

import * as state from '../../../../../../../../../../state'

/** TODO:  */
@ngCore.Component({
  imports: [ds.input.select.single.Component],
  selector: 'atn-entity-record-select',
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.display.Feature} */
  private readonly _displayFeature = ngCore.inject(
    state.display.referenceRecords.Feature,
  )
  /** @see {@link ents.core.dms.models.Entity} */
  public readonly entitySg = ngCore.input<ents.core.dms.models.Entity>(
    undefined,
    {
      alias: 'entity',
    },
  )

  /** @see {@link ents.core.dms.data.Value} */
  public readonly valueSg = ngCore.model<ents.core.dms.data.Value>(undefined, {
    alias: 'value',
  })

  /**
   * The {@link ents.core.dms.models.Entity.Id} of the current
   * {@link ents.core.dms.models.Entity entity}.
   */
  public readonly entityIdSg = ngCore.computed(
    (entity = this.entitySg()) => entity?.id,
  )

  /**
   * The {@link ents.core.dms.models.Entity.Name} of the current
   * {@link ents.core.dms.models.Entity entity}.
   */
  public readonly entityNameSg = ngCore.computed(
    (entity = this.entitySg()) => entity?.name,
  )

  /**
   * The {@link ents.core.dms.data.Record records} of the current
   * {@link ents.core.dms.models.Entity entity}.
   */
  private readonly _recordsSg = ngCore.computed(
    (entityId = this.entityIdSg()) =>
      entityId
        ? this._displayFeature.selectors
            .getRecords({
              entityId,
            })
            .asSignal()
        : [],
  )
  /**
   * Indicates whether the {@link _recordsSg records} for the current
   * {@link ents.core.dms.models.Entity entity} are in a loading state.
   */
  public readonly recordsLoadingSg = ngCore.computed(
    (entityId = this.entityIdSg()) =>
      entityId
        ? this._displayFeature.selectors
            .isLoading({
              entityId,
            })
            .asSignal()
        : false,
  )
  /**
   * Indicates whether the {@link _recordsSg records} for the current
   * {@link ents.core.dms.models.Entity entity} have encountered an error.
   */
  public readonly recordsErrorSg = ngCore.computed(
    (entityId = this.entityIdSg()) =>
      entityId
        ? this._displayFeature.selectors
            .getError({
              entityId,
            })
            .asSignal()
        : undefined,
  )
  /**
   * Same as {@link _recordsSg} but in the form of {@link ds.input.select.models.Item}.
   */
  public readonly recordItemsSg = ngCore.computed(
    (records = this._recordsSg()) =>
      records
        .map<ds.input.select.models.Item>(({ id, name }) => ({
          label: name,
          value: id,
        }))
        .filter(TypeChecker.isNotNullish.raw),
  )

  constructor() {
    ngCore.effect(() => {
      const entityId = this.entityIdSg()

      if (entityId) {
        this._displayFeature.actions.loadRecords
          .from('Dms.AtnEntityRecordSelect')
          .dispatch({
            entityId,
          })
      }
    })
  }
}
